import React, { useState } from 'react';

const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "Can Medisevas HMS, EHR, LMS be accessed on mobile devices?",
      answer: "Indeed, Medisevas HMS, EHR, LMS is entirely compatible with mobile devices, enabling healthcare professionals to oversee hospital operations while on the move, thereby guaranteeing uninterrupted connectivity and management from any location.",
    },
    {
      question: "Can Medisevas HMS, EHR, LMS be customized for specific healthcare needs?",
      answer: "Certainly! Log e Infotech provides affordable HMS, EHR, LMS solutions specifically designed for small healthcare facilities, delivering essential features at a price that meets their requirements.",
    },
    {
      question: "What is the difference between on-premise and cloud-based HMS, EHR, LMS?",
      answer: "On-premise HMS, EHR, LMS are installed and maintained on the servers of your hospital, whereas cloud-based HMS, EHR, LMS are hosted online, providing flexibility, remote access, and enhanced scalability.",
    },
    {
      question: "Which type of training required for Hospital/ Clinical software?",
      answer: "Log e Infotech offers comprehensive training programs for hospital and clinical software users, ensuring they are well-equipped to utilize the system effectively. Training can include on-site sessions, webinars, and access to a library of resources and tutorials.",
    },
    {
      question: "Why customization required in Hospital/Clinical Software?",
      answer: "Customization is essential in Hospital/Clinical Software to meet the unique needs of each healthcare facility. Every hospital has specific workflows, regulatory requirements, and patient care protocols that must be addressed. Tailoring the software ensures it aligns with these needs, improving efficiency and user satisfaction.",
    },
    {
      question: "Why Healthcare data analysis is important?",
      answer: "Healthcare data analysis is crucial for improving patient outcomes, optimizing operational efficiency, and reducing costs. By analyzing data from various sources, healthcare providers can identify trends, make informed decisions, and enhance the quality of care delivered to patients.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <style>{`
        /* FAQ Section Main Styling */
        .faq {
          padding: 60px 0;
          background-color: #ffffff;
          font-family: "Roboto", sans-serif;
        }

        .light-background {
          background-color: #f3f9ff !important;
        }

        .faq .faq-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #2d465e;
          font-family: "Nunito", sans-serif;
        }

        .faq .faq-description {
          font-size: 1rem;
          color: #212529;
          margin-bottom: 2rem;
        }

        .faq .faq-arrow {
          color: #198754;
        }

        /* FAQ Item Box */
        .faq .faq-container .faq-item {
          background-color: #ffffff;
          position: relative;
          padding: 20px;
          margin-bottom: 15px;
          border-radius: 10px;
          overflow: hidden;
          cursor: pointer;
          transition: 0.3s;
          border: 1px solid #e9ecef;
        }

        .faq .faq-container .faq-item:last-child {
          margin-bottom: 0;
        }

        /* FAQ Question (h3) */
        .faq .faq-container .faq-item h3 {
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          margin: 0 30px 0 0;
          transition: 0.3s;
          display: flex;
          align-items: center;
          color: #2d465e;
        }

        .faq .faq-container .faq-item h3:hover {
          color: #198754;
        }

        /* FAQ Content Hidden by Default */
        .faq .faq-container .faq-item .faq-content {
          display: grid;
          grid-template-rows: 0fr;
          transition: 0.3s ease-in-out;
          visibility: hidden;
          opacity: 0;
        }

        .faq .faq-container .faq-item .faq-content p {
          margin-bottom: 0;
          overflow: hidden;
          color: #212529;
          font-size: 15px;
          line-height: 1.6;
        }

        /* Toggle Icon */
        .faq .faq-container .faq-item .faq-toggle {
          position: absolute;
          top: 20px;
          right: 20px;
          font-size: 16px;
          line-height: 0;
          transition: 0.3s;
          color: #212529;
        }

        /* Active State */
        .faq .faq-container .faq-active h3 {
          color: #198754;
        }

        .faq .faq-container .faq-active .faq-content {
          grid-template-rows: 1fr;
          visibility: visible;
          opacity: 1;
          padding-top: 10px;
        }

        .faq .faq-container .faq-active .faq-toggle {
          transform: rotate(90deg);
          color: #198754;
        }

        /* SVG Arrow animation */
        @keyframes shapes-float-faq {
          0%, 100% { transform: scale(0.8) rotate(45deg) translateY(0); }
          50% { transform: scale(0.8) rotate(45deg) translateY(-20px); }
        }

        .faq-arrow svg {
          animation: shapes-float-faq 3s ease-in-out infinite;
          fill: #198754;
          opacity: 0.15;
        }
      `}</style>

      <section className="faq-9 faq section light-background" id="faq">
        <div className="container">
          <div className="container">
            <div className="row">

              {/* Left Side */}
              <div className="col-lg-5">
                <h2 className="faq-title">
                  FAQ About Medisevas Appoinment App Products?
                </h2>
                <p className="faq-description">
                  Medisevas is the answer that propels the healthcare industry forward!
                </p>

                {/* Arrow Section - Desktop Only */}
                <div className="faq-arrow-container d-none d-lg-block">
                  <svg
                    width="240"
                    height="240"
                    viewBox="0 0 200 211"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="curvy-arrow"
                  >
                    <path
                      d="M198.804 194.488C189.279 189.596 179.529 185.52 169.407 182.07L169.384 182.049C169.227 181.994 169.07 181.939 168.912 181.884C166.669 181.139 165.906 184.546 167.669 185.615C174.053 189.473 182.761 191.837 189.146 195.695C156.603 195.912 119.781 196.591 91.266 179.049C62.5221 161.368 48.1094 130.695 56.934 98.891C84.5539 98.7247 112.556 84.0176 129.508 62.667C136.396 53.9724 146.193 35.1448 129.773 30.2717C114.292 25.6624 93.7109 41.8875 83.1971 51.3147C70.1109 63.039 59.63 78.433 54.2039 95.0087C52.1221 94.9842 50.0776 94.8683 48.0703 94.6608C30.1803 92.8027 11.2197 83.6338 5.44902 65.1074C-1.88449 41.5699 14.4994 19.0183 27.9202 1.56641C28.6411 0.625793 27.2862 -0.561638 26.5419 0.358501C13.4588 16.4098 -0.221091 34.5242 0.896608 56.5659C1.8218 74.6941 14.221 87.9401 30.4121 94.2058C37.7076 97.0203 45.3454 98.5003 53.0334 98.8449C47.8679 117.532 49.2961 137.487 60.7729 155.283C87.7615 197.081 139.616 201.147 184.786 201.155L174.332 206.827C172.119 208.033 174.345 211.287 176.537 210.105C182.06 207.125 187.582 204.122 193.084 201.144C193.346 201.147 195.161 199.887 195.423 199.868C197.08 198.548 193.084 201.144 195.528 199.81C196.688 199.192 197.846 198.552 199.006 197.935C200.397 197.167 200.007 195.087 198.804 194.488ZM60.8213 88.0427C67.6894 72.648 78.8538 59.1566 92.1207 49.0388C98.8475 43.9065 106.334 39.2953 114.188 36.1439C117.295 34.8947 120.798 33.6609 124.168 33.635C134.365 33.5511 136.354 42.9911 132.638 51.031C120.47 77.4222 86.8639 93.9837 58.0983 94.9666C58.8971 92.6666 59.783 90.3603 60.8213 88.0427Z"
                      fill="#198754"
                    />
                  </svg>
                </div>
              </div>

              {/* Right Side - FAQ Items */}
              <div className="col-lg-7">
                <div className="faq-container">
                  {faqData.map((item, index) => (
                    <div
                      key={index}
                      className={`faq-item ${activeIndex === index ? 'faq-active' : ''}`}
                      onClick={() => toggleFAQ(index)}
                    >
                      <h3>{item.question}</h3>
                      <div className="faq-content">
                        <p>{item.answer}</p>
                      </div>
                      <i className="faq-toggle bi bi-chevron-right"></i>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqSection;